import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'pcm-ui-font-switch',
	templateUrl: './ui-font-switch.component.html',
	styleUrls: ['./ui-font-switch.component.scss']
})
export class UiFontSwitchComponent implements OnInit {

	@Input() smallActive = false;

	constructor() { }

	ngOnInit() {
	}

	swapActive(event) {
		this.smallActive = !this.smallActive;
	}

	public isSmall() {
		return this.smallActive;
	}

}
